import history from 'services/history'

export default (t) => [
  {
    title: t('Settings:Administration'),
    id: 'admin',
    onClick: () => {
      return history.replace('/administration-permissions/Roles')
    }
  },
  {
    title: t('Settings:Translations'),
    id: 'translations',
    onClick: () => {
      return history.replace('/translations/translationTables')
    }
  }
]
